import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';

import ExposedComponent from './exposed/exposed.component';

const container = document.getElementById('root');
if (container) {
    const root = createRoot(container);
    root.render(
        <BrowserRouter>
            <ExposedComponent />
        </BrowserRouter>,
    );
}
